import { useGetBrandingConfigQuery } from '../../store/chatbox/chatboxApi';
import AiAuthContainer from './AiAuthContainer';
import AuthFooter from './AuthFooter';

const AiAuth = () => {
	const { data: brand } = useGetBrandingConfigQuery('chris-wingpay');
	return (
		<div className="relative flex flex-wrap min-h-screen">
			<div className="w-full md:w-6/12 ml-auto p-2 flex flex-col px-5 md:pr-10 py-5 z-10 bg-[#e8c9c7]">
				<img alt="logo" width={164} src="/logo.svg" />
				<AiAuthContainer />
				<AuthFooter />
			</div>

			<img
				alt="auth"
				className="absolute inset-0 -z-10 w-full h-full object-cover"
				src={
					process.env.REACT_APP_PROJECT === 'nynn'
						? '/images/striped-shirt.jpeg'
						: brand?.metadata.signInImageRHS
				}
			/>
		</div>
	)
}

export default AiAuth;